import { DatePicker, Input, Select, Space } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import type { WorkingReportParams } from "../../../../../../app/features/employee/emp-attendance/emp-attendance.type";
import { useGetAllDepartmentsQuery } from "../../../../../../app/features/employee/emp-dashboard/emp-dashboard.api";
import { ChevronDownIcon, Calendar03Icon, SearchIcon } from '@/icons';
// import { DownloadIcon } from '@/icons';
import { DB_DATE_FORMAT } from "../../../../../../constants/global.constants";
import useDebounce from "../../../../../../hooks/useDebounce";
import { useQueryFilters } from "../../../../../../hooks/useQueryFilters";

const { RangePicker } = DatePicker;

export default function WorkTimeReportFilter() {
  const { keyword, handleInputChange } = useDebounce();
  const [isAllowClear, setIsAllowClear] = useState(false);
  const { filters, setFilterValue, setFilterValues } =
    useQueryFilters<WorkingReportParams>();
  const { data: departmentsData } = useGetAllDepartmentsQuery({
    params: { page: 1, limit: 100, status: 'active' },
  });

  useEffect(() => {
    setFilterValue("search", keyword);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyword]);

  // Set default to current date if no dates are selected
  useEffect(() => {
    setTimeout(() => {
      if (!filters.startDate && !filters.endDate && !isAllowClear) {
        const today = dayjs().format(DB_DATE_FORMAT);
        setFilterValues({
          startDate: today,
          endDate: today,
        });
        setIsAllowClear(false);
      }
    }, 100);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters.startDate, filters.endDate, isAllowClear]);

  return (
    <Space className="filter-section" wrap>
      <Input
        size="large"
        prefix={<SearchIcon size={20} className="px-1" />}
        placeholder="Search Employee ID/Name"
        className="w-72"
        onChange={handleInputChange}
        allowClear
      />

      <RangePicker
        size="large"
        placeholder={["Start Date", "End Date"]}
        className="w-80"
        suffixIcon={<Calendar03Icon size={16} />}
        value={
          filters.startDate && filters.endDate
            ? [
                dayjs(filters.startDate, DB_DATE_FORMAT),
                dayjs(filters.endDate, DB_DATE_FORMAT),
              ]
            : undefined
        }
        onChange={(dates) => {
          if (dates) {
            setFilterValues({
              startDate: dates[0]?.format(DB_DATE_FORMAT),
              endDate: dates[1]?.format(DB_DATE_FORMAT),
            });
          } else {
            setIsAllowClear(true);
            setFilterValues({
              startDate: undefined,
              endDate: undefined,
            });
          }
        }}
        showToday={false}
      />

      <Select
        size="large"
        className="min-w-36"
        placeholder="Department"
        suffixIcon={<ChevronDownIcon size={24} />}
        popupMatchSelectWidth={200}
        value={filters.departmentId}
        onChange={(value) => setFilterValue("departmentId", value)}
        options={
          departmentsData?.data?.data?.map((department) => ({
            value: department.id,
            label: department.name,
          })) || []
        }
        allowClear
      />

      {/* <Button
        size="large"
        disabled
        className="btn-primary !text-neutral-700 !text-base disabled:hover:!text-neutral-700 disabled:hover:opacity-80 font-bold"
      >
        Export
        <DownloadIcon size={16} />
      </Button> */}
    </Space>
  );
}
